// an action for a tree item
export const action = (id, icon, label, onClick, showShortcut = false, isDisabled) => ({
  id,
  icon,
  label,
  onClick,
  showShortcut,
  isDisabled
});
